import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Tabs, Tooltip, message } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { FaSave } from "react-icons/fa";
import Axois from '../utils/axios';
import { Link, useLoaderData, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import useJournalAPI from '../apis/jounalAPI';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EditableTable from '../../globalComponents/EditableTable';
import { paymentColumns, paymentReceiptColumn } from '../utils/tableMockData';
import EventEmitter from '../utils/eventEmitter';




const AddJournals = () => {
  const {accounts, journalTypes, journal} = useLoaderData();
  const [form] = Form.useForm();
  const [name, setName] = useState(journal.name ? journal.name : '');
  const { success, error } = useOutletContext();
  const { create, update } = useJournalAPI();
  const params = useParams();
  const [type, setType] = useState(journal.seo ? journal.type : '');
  const [incoming_payments, setIncomingPayments] = useState(journal.seo ? journal.in_payment_method : []);
  const [outgoingPayments, setOutgoingPayments] = useState(journal.seo ? journal.out_payment_method : []);
  const navigate = useNavigate();

  const onChangeName = e => setName(e.target.value);

  const handleSubmit = () => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replaceAll(' ', '-');
    data['in_payment_method'] = incoming_payments;
    data['out_payment_method'] = outgoingPayments;
    create(data, {success, error});
  }

  const handleUpdate = () => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replaceAll(' ', '-');
    data['in_payment_method'] = incoming_payments;
    data['out_payment_method'] = outgoingPayments;
    // console.log(data)
    update(journal.seo, data, success);
  }

  const addInPayment = () => {
    let inPayment = [...incoming_payments];
    let obj = { key: incoming_payments.length, method: '', name: '', outstanding_account_id: ''};
    inPayment.push(obj);
    setIncomingPayments(inPayment);
  }

  const addOutPayment = () => {
    let outPayment = [...outgoingPayments];
    let obj = { key: outgoingPayments.length, method: '', name: '', outstanding_account_id: ''};
    outPayment.push(obj);
    setOutgoingPayments(outPayment);
  }

  useEffect(() => {
    EventEmitter.subscribe('journal_created', data => {
      navigate('/accounting/journals/'+ data);
    });

    return () => {
      EventEmitter.unsubscribe('journal_created');
    }
  },[])

  const filter = (input, option) => (
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  )

  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/accounting/journals'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Journals</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ journal.name ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {journal.name && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Journal Name" 
          value={name} 
          onChange={onChangeName}
        />
        <Form
          form={form}
          initialValues={journal.name ? journal : {}} 
          labelAlign='left'
          labelCol={{span: 4}}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item label={<span className=''>Type</span>} name={'type'} className='font-bold'>
            <Select showSearch filterOption={filter} options={journalTypes.map(type => ({value: type.name, label: type.name}))} onChange={(v) => setType(v)} style={{width: '250px'}} />
          </Form.Item>

          <Tabs
            type="card"
            items={[
              {
                key: '1',
                label: 'Journal Entries',
                children: <>
                  <Form.Item label='Default Account' name={'default_account'} className='font-bold mb-1'>
                    <Select showSearch filterOption={filter} options={accounts.map(account=> ({value: account._id, label: `${account.code} ${account.name}`}))} style={{width: '250px'}} />
                  </Form.Item>
                  {(type === 'Bank' || type==='Cash') && 
                    <><Form.Item label='Suspense Account' name={'suspense_account'} className='font-bold mb-1'>
                    <Select showSearch filterOption={filter} options={accounts.map(account=> ({value: account._id, label: `${account.code} ${account.name}`}))} style={{width: '250px'}} />
                  </Form.Item>
                  <Form.Item label='Profit Account' name={'profit_account'} className='font-bold mb-1'>
                    <Select showSearch filterOption={filter} options={accounts.map(account=> ({value: account._id, label: `${account.code} ${account.name}`}))} style={{width: '250px'}} />
                  </Form.Item>
                  <Form.Item label='Loss Account' name={'loss_account'} className='font-bold mb-1'>
                    <Select showSearch filterOption={filter} options={accounts.map(account=> ({value: account._id, label: `${account.code} ${account.name}`}))} style={{width: '250px'}} />
                  </Form.Item></>}
                  <Form.Item label='Short Code' name={'code'} className='font-bold mb-1'>
                    <Input type='text' className='border-x-0 border-t-0 input-outline-none font-normal' />
                  </Form.Item>
                </>
              },
              (type === 'Bank' || type === 'Cash') && {
                key: '2',
                label: 'Incoming Payments',
                children: 
                <>
                  <EditableTable 
                    columns={paymentReceiptColumn}
                    dataSource={incoming_payments}
                    setDataSource={setIncomingPayments}
                    addLine={addInPayment}
                    option2={accounts}
                  />
                </>
              },
              (type === 'Bank' || type === 'Cash') && {
                key: '3',
                label: 'Outgoing Payments',
                children: 
                <>
                  <EditableTable 
                    columns={paymentColumns}
                    dataSource={outgoingPayments}
                    setDataSource={setOutgoingPayments}
                    addLine={addOutPayment}
                    option2={accounts}
                  />
                </>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default AddJournals;